<template>
    <div class='image-wrap'>
        <img :class="['offer-tag', {special: isSpecial}]" :src="specialSrc"/>
        <img :src='imageSrc' class='img-fluid' alt='' />
        <span>{{msg}}</span>
    </div>
</template>

<script>
    export default {
        props: [
            'source',
            'vehicle',
        ],
        data: function() {
            return {
                specialSrc: require('@/assets/images/offer-tag.png')
            }
        },
        name: 'VehicleImage',
        computed: {
            imageSrc: function() {
                    return (!this.source)? require('@/assets/images/default-vehicle.svg') : process.env.VUE_APP_API_BASE + process.env.VUE_APP_IMAGE_ENDPOINT + this.source
            },
            msg: function() {
                let msg = '';

                if (this.vehicle.type === 'CAR' && this.vehicle.meta.importFile !== 'LCV') {
                    msg = 'Cars include metallic paint.';
                } else if (this.vehicle.type === 'LCV') {
                    msg = 'Vans include ply lining.';
                }

                return (!this.source) ? "Vehicle image not available" : msg + " Image representative only";
            },
            isSpecial: function() {
                return this.$store.getters.isSpecial;
            }
        }
    }
</script>

<style scoped lang='stylus'>
    .image-wrap
        margin 20px;
        text-align center
        position relative
        padding-top 5%
        span
            display block
            margin-top 1rem
        .offer-tag
            position absolute
            top 0
            right 10px
            display none
            width 15%
            min-width 50px
            &.special
                display block
</style>